module.exports = __webpack_public_path__ + "static/Benz@2x.2d20fe34.png";